import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { ProjectService } from '../../../../../../common/services/project.service';
import { Refund } from '../../../../../../common/models/project';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-refund-view',
  templateUrl: './refund-view.component.html',
  styleUrls: ['./refund-view.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatChipsModule,
    MatSnackBarModule,
  ]
})
export class RefundViewComponent implements OnInit {
  private destroy$ = new Subject<void>();

  projectId!: string;
  refundId!: string;
  refund: Refund | null = null;

  private readonly snackbarConfig: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };

  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {

    this.projectId = this.route.snapshot.paramMap.get('projectId') || '';
    this.refundId = this.route.snapshot.paramMap.get('refundId') || '';

    if (this.projectId && this.refundId) {
      this.loadRefund(this.projectId, this.refundId);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadRefund(projectId: string, refundId: string) {
    this.projectService.getRefund(projectId, refundId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (refund: Refund) => {
        this.refund = refund;
      },
      error: (err) => {
        console.error('Error loading refund', err);
        this.snackBar.open(
          'Dogodila se greška prilikom učitavanja Odluke o povratu.', 'Zatvori', this.snackbarConfig
        );
      }
    });
  }

  getTotalRefundAmount(): number {
    if (!this.refund?.refundItems) {
      return 0;
    }
    return this.refund.refundItems.reduce((total, item) => total + item.refundAmount, 0);
  }
}
